import type {
  CourierDeliveryScheduleUpdateRequestType,
  CourierDeliveryScheduleUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCourierDeliveryScheduleUpdate = (
  courierDeliveryScheduleId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: CourierDeliveryScheduleUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `courier-delivery-schedule/${courierDeliveryScheduleId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as CourierDeliveryScheduleUpdateResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.CourierDeliverySchedule,
          courierDeliveryScheduleId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.CourierDeliverySchedule,
        ],
      });
    },
  });
};
